import { FeatureConfig } from './feature-toggles.config';
import { LocalFeatureTogglerRepository } from './local-feature-toggler.service';
import { HybridFeatureTogglerService } from './hybrid-feature-toggler.service';
import { RemoteFeatureTogglerService } from './remote-feature-toggler.service';

/**
 * Factory function to create a HybridFeatureTogglerService instance
 *
 * @param http The Angular HttpClient
 * @param featureConfig The local feature configuration
 * @param apiConfig The feature API configuration
 * @returns A new HybridFeatureTogglerService instance
 */
export function HybridFeatureTogglerServiceFactory(
  featureConfig: FeatureConfig,
  remoteFeatureTogglerService: RemoteFeatureTogglerService
): HybridFeatureTogglerService {
  const localToggler = new LocalFeatureTogglerRepository(featureConfig);
  return new HybridFeatureTogglerService(localToggler, remoteFeatureTogglerService);
}
